import i18next from 'i18next';

i18next.addResources('es', 'Navbar', {
  logout: 'Cerrar sesión'
});
